import { List, ListItem, ListItemIcon, ListItemText, Paper } from '@mui/material'
import { BinIcon, FileIcon, IconButton } from '@tom-ui/ui'
import { FC } from 'react'
import { DropzoneRootProps } from 'react-dropzone'

type Props = {
  file: { name: string; size: number }
  rootProps: DropzoneRootProps

  setFile: (file: File | undefined) => void
}
export const FileDragAndDropzonePreview: FC<Props> = props => {
  const { file, rootProps, setFile } = props

  return (
    <Paper variant='outlined' {...rootProps} sx={{ height: '100%' }}>
      <List>
        <ListItem
          key={file.name}
          secondaryAction={
            <IconButton
              edge='end'
              onClick={(e: { stopPropagation: () => void }) => {
                e.stopPropagation()
                setFile(undefined)
              }}
            >
              <BinIcon />
            </IconButton>
          }
        >
          <ListItemIcon>
            <FileIcon />
          </ListItemIcon>
          <ListItemText primary={file.name} secondary={`${(file.size / 1024).toFixed(2)} kB`} />
        </ListItem>
      </List>
    </Paper>
  )
}
